<template>
  <div style="height: 100vh">
    <!-- 数字统计 -->
    <div>
      <a-row
        type="flex"
        justify="space-between"
        style="text-align: center"
        :gutter="12"
      >
        <!-- <a-col :span="2"></a-col> -->
        <a-col :span="4">
          <a-card
            style="text-align: center; font-size: 120%; border-radius: 5px"
          >
            <a-statistic
              title="Species"
              :value="445"
              :value-style="{ color: '#3f8600' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="4">
          <a-card
            style="text-align: center; font-size: 120%; border-radius: 5px"
          >
            <a-statistic
              title="RBPs"
              :value="1393413"
              class="demo-class"
              :value-style="{ color: '#cf1322' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="4">
          <a-card
            style="text-align: center; font-size: 120%; border-radius: 5px"
          >
            <a-statistic
              title="RBDs"
              :value="998"
              :value-style="{ color: '#3f8600' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="4">
          <a-card
            style="text-align: center; font-size: 120%; border-radius: 5px"
          >
            <a-statistic
              title="Human RBPs"
              :value="3030"
              :value-style="{ color: '#cf1322' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="4">
          <a-card
            style="text-align: center; font-size: 120%; border-radius: 5px"
          >
            <a-statistic
              title="Disease RBPs"
              :value="838"
              class="demo-class"
              :value-style="{ color: '#3f8600' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="4">
          <a-card
            style="text-align: center; font-size: 120%; border-radius: 5px"
          >
            <a-statistic
              title="CLIP-seq datasets"
              :value="1515"
              class="demo-class"
              :value-style="{ color: '#cf1322' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
      </a-row>
      <!-- 搜索框 -->
      <a-row style="margin-top: 10px">
        <a-col>
          <a-card
            style="
              width: 100%;
              line-height: 25px;
              text-align: center;
              border-radius: 5px;
              border-color: transparent;
              border-width: 2px;
            "
          >
            <a-card
              style="
                width: 100%;
                height: 100%;
                text-align: center;
                border-radius: 5px;
                margin-top: 80px;
                border-color: transparent;
              "
              class="custom-font"
            >
              <h1 class="display-4" style="text-align: center; font-size: 400%">
                <span style="color: rgb(227, 141, 79)">RBP</span>World
              </h1>
              <br />
              <br />
              <a-input
                style="width: 80%; border-radius: 20px"
                v-model="value"
                @pressEnter="searchAll"
                placeholder="eg. RBFOX2 / ENSG00000100320 / 23543"
                size="large"
              />
              <br />
              <br />
              <div style="text-align: center">
                <a-button type="" @click="searchAll">Search</a-button>
              </div>
              <br />
              <br />
              <br />
              <br />
            </a-card> </a-card
        ></a-col>
      </a-row>
      <!-- 欢迎页面 -->
      <a-row :gutter="12" style="margin-top: 10px">
        <a-col :span="12">
          <a-card size="small" style="height: 100%; border-radius: 5px">
            <a slot="title" href="#" style="color: black; font-size: 19px"
              >Welcome to RBPWorld</a
            >
            <div
              class="dashboard-widget-content"
              style="
                overflow-y: auto;

                font-size: 90%;
                text-align: justify;
                height: 365px;
              "
            >
              <div style="padding-right: 8px">
                <span style="font-size: 130%; padding-right: 3px">
                  RNA binding proteins (RBPs) are crucial regulators involved in
                  a wide range of biological processes, and their dysfunctions
                  are associated with numerous human diseases. To facilitate
                  research in this field, we present RBPWorld, a comprehensive
                  and user-friendly database dedicated to eukaryotic RNA binding
                  proteins (RBPs). RBPWorld encompasses a vast collection of
                  1,393,413 RBPs, derived from 445 eukaryotic species, including
                  humans, animals, and plants. Our database offers precise and
                  comprehensive listings of RBPs for each eukaryotic organism,
                  complemented by comprehensive annotations sourced from various
                  public databases. RBPWorld serves as an invaluable resource to
                  explore the world of eukaryotic RBPs and aids in unraveling
                  their intricate functions.</span
                >
                <p style="font-size: 130%; margin-top: 3%">
                  Currently, users can:
                </p>
                <ul
                  style="
                    color: seagreen;
                    font-weight: bold;
                    font-size: 140%;
                    text-align: justify;
                  "
                >
                  <li>Retrieve complete RBP and RBD lists for 445 species;</li>
                  <li>Characterize the comprehensive annotation of RBPs;</li>
                  <li>Explore the clinical relevance of RBPs.</li>
                  <li>
                    Collect an exhaustive inventory of RBPs associated with RNA
                    viruses;
                  </li>
                  <li>
                    Obtain the in-depth analysis of multifunctional molecular
                    attributes, particular sublocations, RNA partners and
                    regulatory networks of RBPs.
                  </li>
                </ul>
              </div>
            </div>
          </a-card></a-col
        >
        <a-col :span="12">
          <a-card size="small" style="height: 100%; border-radius: 5px">
            <a slot="title" href="#" style="color: black; font-size: 19px"
              >Favourite species</a
            >
            <a-row
              type="flex"
              justify="space-between"
              style="text-align: center; padding-right: 10px"
            >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Homo_sapiens')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Homo_sapiens.png"
                    id="Human"
                    alt="Human"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <template slot="description"> Human </template>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Mus_musculus')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Mus_musculus.png"
                    id="Mouse"
                    alt="Mouse"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <template slot="description"> Mouse </template>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Saccharomyces_cerevisiae')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Saccharomyces_cerevisiae.png"
                    id="Yeast"
                    alt="Yeast"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <template slot="description"> Yeast </template>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Danio_rerio')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Danio_rerio.png"
                    id="Zebrafish"
                    alt="Zebrafish"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <span slot="description">
                      <a-tooltip title="Zebrafish"> Zebrafish </a-tooltip>
                    </span>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Drosophila_melanogaster')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Drosophila_melanogaster.png"
                    id="Fly"
                    alt="Fly"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <template slot="description"> Fly </template>
                  </a-card-meta>
                </a-card></a-col
              >
            </a-row>
            <a-row
              type="flex"
              justify="space-between"
              style="text-align: center; padding-right: 10px"
            >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Pan_troglodytes')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Pan_troglodytes.png"
                    id="Pan_troglodytes"
                    alt="Pan_troglodytes"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <span slot="description">
                      <a-tooltip title="Pan_troglodytes">
                        Pan_troglodytes
                      </a-tooltip>
                    </span>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Caenorhabditis_elegans')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Caenorhabditis_elegans.png"
                    id="Worm"
                    alt="Worm"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <template slot="description"> Worm </template>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Arabidopsis_thaliana')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Arabidopsis_thaliana.png"
                    id="Arabidopsis_thaliana"
                    alt="Arabidopsis_thaliana"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <span slot="description">
                      <a-tooltip title="Arabidopsis_thaliana">
                        Arabidopsis_thaliana
                      </a-tooltip>
                    </span>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Oryza_sativa')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Oryza_sativa.png"
                    id="Rice"
                    alt="Rice"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <template slot="description"> Rice </template>
                  </a-card-meta>
                </a-card></a-col
              >
              <a-col :span="4" style="text-align: center">
                <a-card
                  :size="small"
                  hoverable
                  style="width: 110%; height: 90%"
                  @click="goToSpecies('Hordeum_vulgare')"
                >
                  <img
                    slot="cover"
                    src="http://research.gzsys.org.cn/rbpworld/images/species/Hordeum_vulgare.png"
                    id="Hordeum_vulgare"
                    alt="Hordeum_vulgare"
                    height="130"
                  />
                  <a-card-meta style="margin-top: -15px">
                    <span slot="description">
                      <a-tooltip title="Hordeum_vulgare">
                        Hordeum_vulgare
                      </a-tooltip>
                    </span>
                  </a-card-meta>
                </a-card></a-col
              >
            </a-row>
          </a-card></a-col
        >
      </a-row>
      <!-- news workflow -->
      <a-row :gutter="12" style="margin-top: 10px">
        <a-col :span="12">
          <a-card
            size="small"
            style="height: 600px; border-radius: 5px; overflow-y: auto"
          >
            <a slot="title" href="#" style="color: black; font-size: 19px"
              >News</a
            >
            <a-timeline style="margin-top: 10px">
              <a-timeline-item>
                <!-- <a-icontype="check" style="font-size: 16px" /> -->
                <a-icon
                  slot="dot"
                  type="smile"
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#eb2f96"
                />
                <a style="color: black; font-size: 14px">
                  The article on RBPWorld has been published online. Please cite
                  our work:
                  <a
                    href="https://doi.org/10.1093/nar/gkae1028"
                    target="_blank"
                    style="color: blue"
                    >RBPWorld for exploring functions and disease associations
                    of RNA-binding proteins across species</a
                  >
                  <span
                    onmouseover="this.style.cursor='pointer'"
                    @click="downloadFile()"
                    style="
                      font-weight: bolder;
                      color: black;
                      margin-left: 2px;
                      display: inline-block;
                    "
                  >
                    <a-tooltip title="Download now" placement="right">
                      <a-icon type="file-pdf" /> <span> PDF</span>
                    </a-tooltip> </span
                  ><span style="color: blue">.</span> <br /><i>11.05.2024</i>
                </a>
              </a-timeline-item>
              <a-timeline-item>
                <a-icon
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#52c41a"
                />
                <a style="color: black"
                  >RBPWorld has been accepted by
                  <i style="color: blue">Nucleic Acids Research.</i> </a
                ><br /><i>10.11.2024</i>
                <!-- <a
                  href="./Release_Notes.txt"
                  target="_blank"
                  style="color: blue; margin-left: 4px"
                  >Release notes</a
                > -->
              </a-timeline-item>
              <a-timeline-item>
                <a-icon
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#52c41a"
                />
                <a style="color: black">RBPWorld updated to v2.3</a><br /><i
                  >10.03.2024</i
                >
                <a
                  href="./Release_Notes.txt"
                  target="_blank"
                  style="color: blue; margin-left: 4px"
                  >Release notes</a
                ></a-timeline-item
              >
              <a-timeline-item>
                <a-icon
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#52c41a"
                />
                <a style="color: black">RBPWorld updated to v2.2</a><br /><i
                  >06.30.2024</i
                >
                <a
                  href="./Release_Notes.txt"
                  target="_blank"
                  style="color: blue; margin-left: 4px"
                  >Release notes</a
                ></a-timeline-item
              >
              <a-timeline-item>
                <a-icon
                  style="font-size: 16px"
                  theme="twoTone"
                  two-tone-color="#52c41a"
                />
                <a style="color: black">EuRBPDB v2 was renamed as RBPWorld</a
                ><br /><i>08.15.2023</i>
                <a
                  href="./Release_Notes.txt"
                  target="_blank"
                  style="color: blue; margin-left: 4px"
                  >Release notes</a
                ></a-timeline-item
              >
              <a-timeline-item
                ><a style="color: black">EuRBPDB updated to v2.1</a><br /><i
                  >07.04.2023</i
                ></a-timeline-item
              >
              <a-timeline-item
                ><a style="color: black">EuRBPDB v2.0 is online</a><br /><i
                  >06.29.2023</i
                ></a-timeline-item
              >
            </a-timeline>
            <div style="text-align: justify; color: black; font-size: 18px">
              RBPWorld is actively being enhanced to improve user experience.
              For feedback or suggestions, please reach out to us at
              <a href="mailto:liaojy3@mail.sysu.edu.cn"
                >liaojy3@mail.sysu.edu.cn</a
              >
              or
              <a href="mailto:yind3@mail.sysu.edu.cn">yind3@mail.sysu.edu.cn</a
              >. Your contributions are greatly appreciated.
            </div>
            <br />
            <div style="text-align: center">
              <a href="https://clustrmaps.com/site/1c033" title="Visit tracker"
                ><img
                  src="//www.clustrmaps.com/map_v2.png?d=hqfpSGmx61VSo8DWoCWxwt5b1KMw7UWhEeGqTR5PnDU&cl=ffffff"
                  width="50%"
              /></a>
              <!-- <a href="https://www.revolvermaps.com/livestats/5ma1nzay7q0/"
                ><img
                  src="//rf.revolvermaps.com/h/m/a/0/ff0000/128/0/5ma1nzay7q0.png"
                  width="50%"
                  alt="Map"
              /></a> -->
            </div>
          </a-card></a-col
        >
        <a-col :span="12">
          <a-card
            size="small"
            style="height: 600px; border-radius: 5px; overflow-y: auto"
          >
            <a slot="title" href="#" style="color: black; font-size: 19px"
              >Features</a
            >
            <!-- <a-row :gutter="[12, 12]" style="padding-left: 30px">
              <a-col :span="12"><rbds /></a-col>
              <a-col :span="12"><rbpomes /></a-col>
            </a-row>
            <a-row :gutter="[12, 12]" style="padding-left: 30px">
              <a-col :span="12"><species /></a-col>
              <a-col :span="12"><rbps /></a-col>
            </a-row> -->
            <!-- <a slot="extra" href="#">more</a> -->
            <img
              src="http://research.gzsys.org.cn/rbpworld/images/FigureFramework.png"
              width="100%"
              height="100%"
            /> </a-card
        ></a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
// import rbds from "./homeFeatures/barRBDs.vue";
// import rbpomes from "./homeFeatures/RBPomes.vue";
// import species from "./homeFeatures/speciesPage.vue";
// import rbps from "./homeFeatures/RBPnum.vue";

export default {
  // components: { rbds, rbpomes, species, rbps },
  data() {
    return {
      value: "",
    };
  },
  methods: {
    downloadFile() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href = "http://research.gzsys.org.cn/rbpworld/gkae1028.pdf";

      link.setAttribute("download", "gkae1028.pdf");

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    searchAll() {
      if (this.value != "") {
        let href =
          "http://research.gzsys.org.cn/rbpworld/#/searh_all?identity=" +
          this.value.trim();
        window.open(href, "_blank");
      } else {
        let href =
          "http://research.gzsys.org.cn/rbpworld/#/searh_all?identity=RBFOX2";
        window.open(href, "_blank");
      }
    },
    goToSpecies(value) {
      let href =
        "http://research.gzsys.org.cn/rbpworld/#/species_overview?species=" +
        value +
        "&family=";
      window.open(href, "_blank");
    },
  },
};
</script>

<style>
.custom-font {
  font-family: sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
}
</style>
